/** The install card (6 Sep 2026): shown on the Gastos home until the app is installed or the person says "Ahora no". Not an artboard; state/install.ts holds the browser event. */
import { Button, Icon } from '../theme/ui.tsx';
import { useInstall } from '../state/install.ts';

export function InstallCard() {
  const i = useInstall();
  if (!i.show) return null;
  return (
    <div className="card card--pad" style={{ margin: '0 20px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', gap: 13, alignItems: 'flex-start' }}>
        <Icon.Download size={21} color="var(--green)" width={1.8} style={{ flexShrink: 0, marginTop: 2 }} />
        <div className="grow">
          <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.008em' }}>Instala Gastos en tu teléfono</div>
          <div className="sub" style={{ marginTop: 5, lineHeight: 1.45 }}>
            {i.canPrompt
              ? 'Queda como una app más: la cámara a un toque, y puedes mandar tickets desde el correo con "Compartir".'
              : <>En Safari toca <b>Compartir</b> y luego <b>Agregar a pantalla de inicio</b>. Queda como una app más, con la cámara a un toque.</>}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        {i.canPrompt && <Button sm onClick={i.install} icon={<Icon.Download size={17} width={1.9} />}>Instalar la app</Button>}
        <Button sm variant="ghost" inline onClick={i.dismiss}>Ahora no</Button>
      </div>
    </div>
  );
}
